import React, { useState, useEffect } from "react";
import { emptyAvatar, ZoomIcon, FolderIcon } from "../../imagepath";
import { getFile } from "../../../lib/file";
import { getIdData } from "../../../lib/studentinfo";
import { Link } from "react-router-dom";
import { useNavigate, useParams } from "react-router-dom";

export default function StudentInfoBox({ slug }) {
  const [studentInfo, setStudentInfo] = useState(0);
  const [avatar, setAvatar] = useState();
  const navigate = useNavigate();

  console.log("StudentInfo slug",slug);

  const handleUpdate = async (e) => {
    navigate(`/instructor/student-profile-edit/${slug}`);
  }
  async function GetData() {
    const std = await getIdData(slug);
    setStudentInfo(std);
    console.log("std", std);


    if (std[0].avatar_url) {
      const avt = await getFile(std[0].avatar_url);
      setAvatar(avt.publicUrl);
    }
  }

  useEffect(() => {
    if(slug)
    GetData();
  }, [slug]);

  return (
    <div className="settings-widget2">
      <div className="settings-inner-blk p-0">
        {studentInfo && (
          <>
            <div className="row m-2">
              <div className="col-2">
                <div className="student-img">
                  <img
                    className="rounded-circle float-start"
                    style={{ height: "100px" }}
                    alt="Students Info"
                    src={avatar ? avatar : emptyAvatar}
                  />
                </div>
              </div>
              <div className="col-6 align-items-center mt-3">
                <h3>{studentInfo[0].name + " " + studentInfo[0].surname}</h3>
                <p>
                  {studentInfo[0].schoolname + " - " + studentInfo[0].class}
                </p>

              </div>
              <div className="col-4  mt-4 d-flex justify-content-between">
                {/*}
                <div>
                  <Link
                    to={studentInfo[0].meetlink} target="_blank"
                  >
                    <span className="">
                      <img src={ZoomIcon} alt="" />
                    </span>
                  </Link>
                  <Link
                    to={studentInfo[0].folderlink} target="_blank"
                  >
                    <span className="">
                      <img src={FolderIcon} alt="" />
                    </span>
                  </Link>
                </div>
                */}
                {/*}
                <div className="ticket-btn-grp">
                  {taskshow ? (
                    <Link
                      to={`/instructor/instructor-taskmanage-edit/Student/${slug}`}
                    >
                      Add Task to Student
                    </Link>
                  ) : (
                    ""
                  )}
                </div>
                */}
{/*}
                <div>
                  <a
                    className="btn btn-outline-info"
                    data-bs-toggle="collapse"
                    href={`#collapseExample`}
                    role="button"
                    aria-expanded="false"
                    aria-controls={`collapseExample`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      fill="currentColor"
                      className="bi bi-chevron-double-down"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                      />
                      <path
                        fillRule="evenodd"
                        d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                      />
                    </svg>
                  </a>
                </div>
                */}
              </div>
            </div>
            <div className="checkout-form personal-address add-course-info">
              <div className="row m-2">
                <div className="col-lg-4">
                  <div className="form-group">
                    <label className="form-control-label">Graduation Year</label>
                    <p className="break-line">{studentInfo ? studentInfo[0].graduateyear : ""}</p>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group">
                    <label className="form-control-label">GPA</label>
                    <p className="break-line">{studentInfo ? studentInfo[0].gpa : ""}</p>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group">
                    <label className="form-control-label">SAT / PSAT</label>
                    <p className="break-line">{studentInfo ? studentInfo[0].satpsat : ""}</p>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group">
                    <label className="form-control-label">Practice SAT</label>
                    <p className="break-line">{studentInfo ? studentInfo[0].statetest : ""}</p>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group">
                    <label className="form-control-label">Major</label>
                    <p className="break-line">{studentInfo ? studentInfo[0].major : ""}</p>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group">
                    <label className="form-label">Career</label>
                    <p className="break-line">{studentInfo ? studentInfo[0].career : ""}</p>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group">
                    <label className="form-label">Five Adjectives</label>
                    <p className="break-line">{studentInfo ? studentInfo[0].fiveAdjectives : ""}</p>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group">
                    <label className="form-label">About my High School</label>
                    <p className="break-line">
                      {studentInfo ? studentInfo[0].hsSchoolStatistics : ""}
                    </p>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group">
                    <label className="form-label">Top Three Colleges Choices</label>
                    <p className="break-line">{studentInfo ? studentInfo[0].topThreeColleges : ""}</p>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group">
                    <label className="form-label">Letter of Recommendation</label>
                    <p className="break-line">{studentInfo ? studentInfo[0].lor : ""}</p>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group">
                    <label className="form-label">Activities</label>
                    <p className="break-line">{studentInfo ? studentInfo[0].activities : ""}</p>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group">
                    <label className="form-label">College Essay</label>
                    <p className="break-line">{studentInfo ? studentInfo[0].collegeEssay : ""}</p>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group">
                    <label className="form-label">Counser&apos;s Comment</label>
                    <p className="break-line">{studentInfo ? studentInfo[0].instructorNote : ""}</p>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group">
                    <label className="form-label">Student&apos;s Comment</label>
                    <p className="break-line">{studentInfo ? studentInfo[0].studentNote : ""}</p>
                  </div>
                </div>
                <button 
                  onClick={handleUpdate}
                  className="update_btn_for_students"
                  data-bs-dismiss="modal"
                >
                  UPDATE
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
